import { render } from "./Contactus.vue?vue&type=template&id=da72f3c0"
import script from "./Contactus.vue?vue&type=script&lang=js"
export * from "./Contactus.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Evuri\\New Owners\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__